<div class="amadeus-direct-style">
  <ng-container *ngIf="userLoggedOut">
    <div class="simple-header">
      <div class="row">
        <div class="col-12">
          <a [routerLink]="'/'" class="header-logo-wrap">
            <img src="/assets/images/login-panel/logo-full.svg" alt="Amadeus Direct" />
          </a>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="error-page-wrap">
    <div class="error-page-top">
      <div class="container position-relative overflow-hidden">
        <div class="error-type" [innerHTML]="errorPageType"></div>
        <div class="error-number-holder">
          <img [src]="errorhref" alt="Amadeus Direct error" />
        </div>
        <div class="error-page-title" [innerHTML]="errorPageTitle"></div>
        <div class="error-page-subtitle" [innerHTML]="errorPageSubtitle"></div>
      </div>
    </div>

    <ng-container *ngIf="showSocial">
      <div class="error-page-bottom">
        <div class="container position-relative overflow-hidden">
          <div class="socials-title" i18n="@@exceptions.errorPageSocialLinksTitle">
            Check out our social media channels in the meantime
          </div>
          <ul class="error-page-socials clearfix">
            <li *ngIf="facebook">
              <a href="{{ facebook }}" target="_blank" rel="noopener noreferrer" class="fb">
                <svg style="width: 90px; height: 90px;">
                  <use href="/assets/images/svg_ico/icons.svg#ic_facebook_outline"></use>
                </svg>
              </a>
            </li>
            <li *ngIf="twitter">
              <a href="{{ twitter }}" target="_blank" rel="noopener noreferrer" class="twitter">
                <svg style="width: 90px; height: 90px;">
                  <use href="/assets/images/svg_ico/icons.svg#ic_twitter_outline"></use>
                </svg>
              </a>
            </li>
            <li *ngIf="linkedin">
              <a href="{{ linkedin }}" target="_blank" rel="noopener noreferrer" class="linkedin">
                <svg style="width: 90px; height: 90px;">
                  <use href="/assets/images/svg_ico/icons.svg#ic_linkedin_outline"></use>
                </svg>
              </a>
            </li>
            <li *ngIf="youtube">
              <a href="{{ youtube }}" target="_blank" rel="noopener noreferrer" class="youtube">
                <svg style="width: 90px; height: 90px;">
                  <use href="/assets/images/svg_ico/icons.svg#ic_youtube_outline"></use>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="userLoggedOut">
    <footer class="footer" style="position: inherit;">
      <div class="container">
        <div class="to-top">
          <svg style="width: 24px; height: 24px;">
            <use href="/assets/images/svg_ico/icons.svg#arrow_grey"></use>
          </svg>
        </div>
        <div class="footer-bottom">
          <div class="row">
            <div class="col-4 footer-left">
              <div class="footer-logo-wrap">
                <a [routerLink]="'/'" class="footer-logo">
                  <img
                    src="/assets/images/login-panel/logo-full-blue.svg"
                    alt="Amadeus Direct"
                  />
                </a>
              </div>
              <div class="footer-copyrights">&copy; {{ landingNewDesignCopyrights }}</div>
            </div>
            <div class="col-8 footer-right">
              <div class="footer-legal-docs-links">
                <ng-container *ngIf="legal && legal.length">
                  <ng-container *ngFor="let doc of legal">
                    <ng-container *ngIf="doc['cms_page_code'] === CMS.TERMS_OF_USE">
                      <a [routerLink]="['/content/', CMS.TERMS_OF_USE]" target="_blank">{{ landingTermsOfUse }}</a>
                    </ng-container>

                    <ng-container *ngIf="doc['cms_page_code'] === CMS.COOKIES">
                      <a [routerLink]="['/content/', CMS.COOKIES]" target="_blank">{{ landingCookiesPolicy }}</a>
                    </ng-container>

                    <ng-container *ngIf="doc['cms_page_code'] === CMS.PRIVACY_POLICY">
                      <a [routerLink]="['/content/', CMS.PRIVACY_POLICY]" target="_blank">{{
                        'landingPrivacyPolicy'
                      }}</a>
                    </ng-container>

                    <ng-container *ngIf="doc['cms_page_code'] === CMS.IMPRESSUM">
                      <a [routerLink]="['/content/', CMS.IMPRESSUM]" target="_blank">{{
                        'footerContentMarketing-impressum'
                      }}</a>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </ng-container>
</div>
